import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


const Rules = () => {
  return (
    <div>
      <Container>
        <Row>
          <h3 className='mt-5 mb-5'>Admission Guidelines</h3>
          <Col md={9}>
            <h6 className='mt-2 mb-5'>The procedure of admission begins with registration. The student seeking admission has to
              deposit Rs. 300.00 (per student) as Registration fee for obtaining a registration form and
              prospectus.</h6>
              <ul className='fw-bold'>
                <li>Admission is considered only after the student clears the admission test and personal interview.</li>
                <li>A student who qualifies the test must be admitted within a week from the date of test failing which his/her registration is cancelled automatically.</li>
                <li>T.C/Birth Certificate along with a mark-sheet is a must.</li>
                <li>The minimum age is 3 years at the commencement of the session for Nursery class.</li>
                <li>Every student has to submit his/her two recent passport size photographs for admission.</li>
                <li>All entries on the admission form must be written legibly and correctly in bold capital letters.</li>
              </ul>
          </Col>
        </Row>
        <hr />
        <Row>
          <h3 className='mt-5 mb-2'>Withdrawals</h3>
          <Col md={9}>
          <p>A student seeking withdrawal should give one months’ notice in advance. Students withdrawing, in the middle of a session will normally be required to pay the fee for the whole session. Moreover, Transfer Certificate is issued only after remittance of all dues.</p>
          </Col>
        </Row>
        <hr />
        <Row>
          <h3 className='mt-5 mb-2'>Dismissal</h3>
          <Col md={9}>
          <h6>A child may be removed from the school on any of the following grounds :-</h6>
          <ul className='fw-bold mb-5'>
            <li>Misbehaviour inside the school premises.</li>
            <li>Absence from the class for more than the prescribed days (i.e. five consecutive days/seven days in a month without any application).</li>
            <li>Failure in a class for two consecutive years.</li>
            <li>Any disciplinary action in the school premises or with the mates or any staff members(either teaching or non-teaching).</li>
            <li>Non-payment of school fees for three consecutive months.</li>
          </ul>
          </Col>
        </Row>
        <hr />
      </Container>

    </div>
  )
}

export default Rules